import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';

const Toast = () => {
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const handleToast = (event) => {
      setToast(event.detail);
      setTimeout(() => setToast(null), event.detail.duration);
    };

    document.addEventListener('cart:notification', handleToast);
    return () => document.removeEventListener('cart:notification', handleToast);
  }, []);

  if (!toast) return null;

  const bgColor =
    {
      error: 'bg-error',
      warning: 'bg-warning',
      success: 'bg-surface-green',
    }[toast.type] || 'bg-error';

  return (
    <div className="animate-fadeIn fixed right-20 top-20 z-[100]">
      <div className={`rounded ${bgColor} px-20 py-12 text-white shadow-lg`}>{toast.message}</div>
    </div>
  );
};

export default Toast;
